import TextBlock from 'components/Common/TextBlock/TextBlock'

export default function MusicAbout() {
	return (
		<div className='about-text'>
			<TextBlock>
				I didn’t always know I wanted to be a musician, but I knew I loved music
				from when I first started playing the baritone in 5th grade. For the
				entirety of my education, I participated in every type ensemble I could get
				myself into. I excelled in music early on in middle school and that gave me
				the confidence to be a true leader in every musical program I was a part of.
				From high school through all of my higher education, I received numerous
				scholarships and was assigned principal trombone or euphonium in nearly
				every ensemble I participated in.
			</TextBlock>
			<TextBlock>
				My goal is to use music to further develop what makes us uniquely human,
				whether that is through performing a thought provoking piece of music,
				teaching youth how to be better musicians and develop themselves as a whole,
				or just having a good conversation about something musical.
			</TextBlock>
		</div>
	)
}
